module.exports = __webpack_public_path__ + "assets/34707efe23c4e5b3cba92a3e478680be.png";